import { AdKind, AdsPlacementModel } from '@marketplace-web/ads/ads-data'

export function getAdPlacementId(placementConfig: AdsPlacementModel) {
  let code = ''
  const separator = '_'

  if ([AdKind.Rtb, AdKind.Van].includes(placementConfig.kind)) {
    code = [
      placementConfig.countryCode,
      placementConfig.platform,
      placementConfig.page,
      placementConfig.shape,
    ].join(separator)
  }

  if (placementConfig.mediation) {
    code = [code, placementConfig.mediation].join(separator)
  }

  return code
}

export const MOCK_AD_SAMPLE_HTML = `
<!DOCTYPE html>
<html>
  <head>
    <title>Target All 1</title>
    <meta name="viewport" content="width=device-width, initial-scale=1" />
  </head>
  <body>
    <a href="https://target.link.com" target="_top">
      <img src="https://img.url.com" alt="" />
    </a>
  </body>
</html>
`

export function getIabCategoriesById(id?: number): Array<string> | null {
  switch (id) {
    case 4:
      return ['IAB18-5']
    case 5:
      return ['IAB18-5']
    case 8:
      return ['IAB18-5']
    case 9:
      return ['IAB18-5']
    case 10:
      return ['IAB18-5']
    case 11:
      return ['IAB18-5']
    case 12:
      return ['IAB18-5']
    case 13:
      return ['IAB18-5']
    case 14:
      return ['IAB18-5']
    case 15:
      return ['IAB18-5']
    case 16:
      return ['IAB18-5']
    case 18:
      return ['IAB18-5']
    case 19:
      return ['IAB18-5']
    case 20:
      return ['IAB18-5']
    case 21:
      return ['IAB18-4']
    case 22:
      return ['IAB18-6']
    case 26:
      return ['IAB18-6']
    case 28:
      return ['IAB17-38']
    case 29:
      return ['IAB7-39']
    case 30:
      return ['IAB17', 'IAB18-5']
    case 32:
      return ['IAB18-5']
    case 34:
      return ['IAB18-5']
    case 73:
      return ['IAB18-5']
    case 76:
      return ['IAB18-5']
    case 77:
      return ['IAB18-5']
    case 79:
      return ['IAB18-5']
    case 80:
      return ['IAB18-5']
    case 82:
      return ['IAB18-6']
    case 83:
      return ['IAB18-5']
    case 84:
      return ['IAB17-38']
    case 85:
      return ['IAB18-5']
    case 86:
      return ['IAB18-6']
    case 87:
      return ['IAB18-6']
    case 88:
      return ['IAB18-6']
    case 89:
      return ['IAB18-6']
    case 90:
      return ['IAB18-6']
    case 91:
      return ['IAB18-6']
    case 92:
      return ['IAB18-6']
    case 94:
      return ['IAB18-6']
    case 95:
      return ['IAB18-4']
    case 96:
      return ['IAB18-6']
    case 97:
      return ['IAB18-6']
    case 98:
      return ['IAB18-6']
    case 99:
      return ['IAB18-6']
    case 119:
      return ['IAB7-39']
    case 120:
      return ['IAB7-39']
    case 123:
      return ['IAB7-39']
    case 124:
      return ['IAB7-39']
    case 139:
      return ['IAB7-39']
    case 140:
      return ['IAB18-1']
    case 141:
      return ['IAB18-1']
    case 142:
      return ['IAB18-1']
    case 143:
      return ['IAB18-1']
    case 144:
      return ['IAB18-1']
    case 145:
      return ['IAB18-1']
    case 146:
      return ['IAB18-1']
    case 152:
      return ['IAB18-1']
    case 153:
      return ['IAB18-1']
    case 156:
      return ['IAB18-6']
    case 157:
      return ['IAB18-6']
    case 158:
      return ['IAB18-6']
    case 159:
      return ['IAB18-6']
    case 160:
      return ['IAB18-6']
    case 161:
      return ['IAB18-1']
    case 162:
      return ['IAB18-4']
    case 163:
      return ['IAB18-4']
    case 164:
      return ['IAB18-4']
    case 165:
      return ['IAB18-4']
    case 166:
      return ['IAB18-4']
    case 167:
      return ['IAB18-4']
    case 176:
      return ['IAB18-5']
    case 178:
      return ['IAB18-5']
    case 179:
      return ['IAB18-5']
    case 183:
      return ['IAB18-5']
    case 184:
      return ['IAB18-5']
    case 185:
      return ['IAB18-5']
    case 187:
      return ['IAB18-5']
    case 189:
      return ['IAB18-5']
    case 190:
      return ['IAB18-5']
    case 191:
      return ['IAB18-5']
    case 192:
      return ['IAB18-5']
    case 193:
      return ['IAB18-5']
    case 194:
      return ['IAB18-5']
    case 195:
      return ['IAB18-5']
    case 196:
      return ['IAB18-5']
    case 197:
      return ['IAB18-5']
    case 198:
      return ['IAB18-5']
    case 199:
      return ['IAB18-5']
    case 200:
      return ['IAB18-5']
    case 203:
      return ['IAB18-5']
    case 204:
      return ['IAB18-5']
    case 205:
      return ['IAB18-5']
    case 211:
      return ['IAB18-5']
    case 213:
      return ['IAB18-5']
    case 215:
      return ['IAB18-5']
    case 218:
      return ['IAB18-5']
    case 219:
      return ['IAB17-38', 'IAB 18-5']
    case 220:
      return ['IAB17-38', 'IAB 18-5']
    case 221:
      return ['IAB18-5']
    case 222:
      return ['IAB18-5']
    case 223:
      return ['IAB18-5']
    case 224:
      return ['IAB18-5']
    case 225:
      return ['IAB18-5']
    case 227:
      return ['IAB18-5']
    case 228:
      return ['IAB18-5']
    case 229:
      return ['IAB7-39']
    case 230:
      return ['IAB18-6']
    case 231:
      return ['IAB18-6']
    case 234:
      return ['IAB18-6']
    case 241:
      return ['IAB18-4']
    case 242:
      return ['IAB18-4']
    case 243:
      return ['IAB18-4']
    case 244:
      return ['IAB18-4']
    case 246:
      return ['IAB18-6']
    case 247:
      return ['IAB18-6']
    case 248:
      return ['IAB18-6']
    case 257:
      return ['IAB18-5']
    case 259:
      return ['IAB18-5']
    case 260:
      return ['IAB18-5']
    case 261:
      return ['IAB18-5']
    case 263:
      return ['IAB18-5']
    case 264:
      return ['IAB18-5']
    case 265:
      return ['IAB18-5']
    case 266:
      return ['IAB18-5']
    case 267:
      return ['IAB18-5']
    case 268:
      return ['IAB18-5']
    case 271:
      return ['IAB18-5']
    case 272:
      return ['IAB18-5']
    case 287:
      return ['IAB18-6']
    case 288:
      return ['IAB18-6']
    case 525:
      return ['IAB18-5']
    case 526:
      return ['IAB18-5']
    case 529:
      return ['IAB18-5']
    case 532:
      return ['IAB18-5']
    case 534:
      return ['IAB18-5']
    case 536:
      return ['IAB18-5']
    case 538:
      return ['IAB18-5']
    case 543:
      return ['IAB18-5']
    case 552:
      return ['IAB18-6']
    case 553:
      return ['IAB18-5']
    case 560:
      return ['IAB18-5']
    case 571:
      return ['IAB18-5']
    case 572:
      return ['IAB18-5']
    case 573:
      return ['IAB18-5']
    case 574:
      return ['IAB18-5']
    case 575:
      return ['IAB18-5']
    case 576:
      return ['IAB18-5']
    case 577:
      return ['IAB18-5']
    case 578:
      return ['IAB18-5']
    case 579:
      return ['IAB18-5']
    case 580:
      return ['IAB18-5']
    case 581:
      return ['IAB18-5']
    case 582:
      return ['IAB18-5']
    case 583:
      return ['IAB18-5']
    case 584:
      return ['IAB18-5']
    case 585:
      return ['IAB18-5']
    case 586:
      return ['IAB18-5']
    case 587:
      return ['IAB18-5']
    case 588:
      return ['IAB18-5']
    case 948:
      return ['IAB18-1']
    case 950:
      return ['IAB18-1']
    case 956:
      return ['IAB18-1']
    case 958:
      return ['IAB18-1']
    case 960:
      return ['IAB18-1']
    case 962:
      return ['IAB18-1']
    case 964:
      return ['IAB18-1']
    case 967:
      return ['IAB18-1']
    case 968:
      return ['IAB18-1']
    case 971:
      return ['IAB18-1']
    case 1030:
      return ['IAB18-5']
    case 1035:
      return ['IAB18-5']
    case 1037:
      return ['IAB18-5']
    case 1041:
      return ['IAB18-5']
    case 1042:
      return ['IAB18-5']
    case 1043:
      return ['IAB18-5']
    case 1044:
      return ['IAB18-5']
    case 1045:
      return ['IAB18-5']
    case 1049:
      return ['IAB18-5']
    case 1055:
      return ['IAB18-5']
    case 1056:
      return ['IAB18-5']
    case 1057:
      return ['IAB18-5']
    case 1058:
      return ['IAB18-5']
    case 1059:
      return ['IAB18-5']
    case 1060:
      return ['IAB18-5']
    case 1061:
      return ['IAB18-5']
    case 1065:
      return ['IAB18-5']
    case 1066:
      return ['IAB18-5']
    case 1067:
      return ['IAB18-5']
    case 1070:
      return ['IAB18-5']
    case 1071:
      return ['IAB18-5']
    case 1076:
      return ['IAB18-5']
    case 1078:
      return ['IAB18-5']
    case 1079:
      return ['IAB18-5']
    case 1080:
      return ['IAB18-5']
    case 1086:
      return ['IAB18-5']
    case 1087:
      return ['IAB18-5']
    case 1090:
      return ['IAB18-5']
    case 1099:
      return ['IAB18-5']
    case 1100:
      return ['IAB18-5']
    case 1101:
      return ['IAB18-5']
    case 1103:
      return ['IAB18-5']
    case 1123:
      return ['IAB18-5']
    case 1125:
      return ['IAB18-5']
    case 1126:
      return ['IAB18-5']
    case 1128:
      return ['IAB18-5']
    case 1129:
      return ['IAB18-5']
    case 1131:
      return ['IAB18-5']
    case 1132:
      return ['IAB18-5']
    case 1134:
      return ['IAB18-5']
    case 1140:
      return ['IAB18-5']
    case 1176:
      return ['IAB18-5']
    case 1177:
      return ['IAB18-5']
    case 1178:
      return ['IAB18-5']
    case 1179:
      return ['IAB18-5']
    case 1181:
      return ['IAB18-5']
    case 1182:
      return ['IAB18-5']
    case 1183:
      return ['IAB18-5']
    case 1184:
      return ['IAB18-5']
    case 1185:
      return ['IAB18-5']
    case 1186:
      return ['IAB18-5']
    case 1187:
      return ['IAB18-4']
    case 1193:
      return ['IAB18-5']
    case 1194:
      return ['IAB18-5']
    case 1195:
      return ['IAB18-5']
    case 1196:
      return ['IAB18-5']
    case 1197:
      return ['IAB18-5']
    case 1198:
      return ['IAB18-5']
    case 1199:
      return ['IAB18-5']
    case 1200:
      return ['IAB18-5']
    case 1201:
      return ['IAB18-5']
    case 1202:
      return ['IAB18-5']
    case 1203:
      return ['IAB18-5']
    case 1204:
      return ['IAB18-5']
    case 1205:
      return ['IAB18-5']
    case 1206:
      return ['IAB18-5']
    case 1223:
      return ['IAB18-5']
    case 1224:
      return ['IAB18-5']
    case 1225:
      return ['IAB18-5']
    case 1226:
      return ['IAB18-5']
    case 1227:
      return ['IAB18-5']
    case 1230:
      return ['IAB18-5']
    case 1231:
      return ['IAB18-5']
    case 1233:
      return ['IAB18-5']
    case 1238:
      return ['IAB18-5']
    case 1242:
      return ['IAB18-5']
    case 1243:
      return ['IAB18-5']
    case 1244:
      return ['IAB18-5']
    case 1245:
      return ['IAB18-5']
    case 1246:
      return ['IAB18-5']
    case 1247:
      return ['IAB18-5']
    case 1248:
      return ['IAB18-5']
    case 1249:
      return ['IAB18-5']
    case 1250:
      return ['IAB18-5']
    case 1251:
      return ['IAB18-5']
    case 1252:
      return ['IAB18-5']
    case 1253:
      return ['IAB17', 'IAB18-5']
    case 1254:
      return ['IAB18-5']
    case 1255:
      return ['IAB18-5']
    case 1256:
      return ['IAB18-5']
    case 1257:
      return ['IAB18-6']
    case 1258:
      return ['IAB18-6']
    case 1262:
      return ['IAB7-39', 'IAB18-5']
    case 1263:
      return ['IAB7-39', 'IAB18-5']
    case 1264:
      return ['IAB18-1']
    case 1439:
      return ['IAB17', 'IAB18-5']
    case 1440:
      return ['IAB17', 'IAB18-6']
    case 1441:
      return ['IAB17', 'IAB18-6']
    case 1443:
      return ['IAB17', 'IAB18-6']
    case 1444:
      return ['IAB17', 'IAB18-6']
    case 1445:
      return ['IAB17']
    case 1446:
      return ['IAB17', 'IAB18-6']
    case 1452:
      return ['IAB17', 'IAB18-5']
    case 1453:
      return ['IAB17', 'IAB18-5']
    case 1467:
      return ['IAB17', 'IAB18-5']
    case 1470:
      return ['IAB17', 'IAB18-6']
    case 1471:
      return ['IAB17', 'IAB18-6']
    case 1473:
      return ['IAB17', 'IAB18-6']
    case 1474:
      return ['IAB17', 'IAB18-6']
    case 1475:
      return ['IAB17']
    case 1476:
      return ['IAB17', 'IAB18-6']
    case 1496:
      return ['IAB6']
    case 1497:
      return ['IAB17-3']
    case 1498:
      return ['IAB10-7']
    case 1499:
      return ['IAB9']
    case 1501:
      return ['IAB1-1']
    case 1502:
      return ['IAB6']
    case 1508:
      return ['IAB18-6']
    case 1509:
      return ['IAB6']
    case 1510:
      return ['IAB18-5']
    case 1511:
      return ['IAB18-6']
    case 1514:
      return ['IAB18-5']
    case 1515:
      return ['IAB18-5']
    case 1516:
      return ['IAB18-5']
    case 1517:
      return ['IAB18-5']
    case 1518:
      return ['IAB18-5']
    case 1519:
      return ['IAB18-5']
    case 1521:
      return ['IAB18-5']
    case 1525:
      return ['IAB18-5']
    case 1526:
      return ['IAB18-5']
    case 1528:
      return ['IAB18-5']
    case 1530:
      return ['IAB18-5']
    case 1533:
      return ['IAB18-5']
    case 1534:
      return ['IAB18-5']
    case 1535:
      return ['IAB18-5']
    case 1536:
      return ['IAB18-5']
    case 1537:
      return ['IAB18-5']
    case 1538:
      return ['IAB18-5']
    case 1539:
      return ['IAB18-5']
    case 1540:
      return ['IAB18-5']
    case 1541:
      return ['IAB18-5']
    case 1542:
      return ['IAB18-5']
    case 1543:
      return ['IAB18-5']
    case 1544:
      return ['IAB18-5']
    case 1548:
      return ['IAB18-5']
    case 1549:
      return ['IAB18-5']
    case 1550:
      return ['IAB18-5']
    case 1551:
      return ['IAB18-5']
    case 1553:
      return ['IAB18-5']
    case 1554:
      return ['IAB18-5']
    case 1559:
      return ['IAB18-5']
    case 1560:
      return ['IAB18-5']
    case 1562:
      return ['IAB18-5']
    case 1565:
      return ['IAB18-5']
    case 1567:
      return ['IAB6']
    case 1568:
      return ['IAB18-5']
    case 1569:
      return ['IAB6']
    case 1570:
      return ['IAB6']
    case 1571:
      return ['IAB18-6']
    case 1572:
      return ['IAB6']
    case 1573:
      return ['IAB6']
    case 1574:
      return ['IAB18-6']
    case 1577:
      return ['IAB18-6']
    case 1578:
      return ['IAB18-6']
    case 1580:
      return ['IAB18-6']
    case 1581:
      return ['IAB18-6']
    case 1582:
      return ['IAB18-6']
    case 1584:
      return ['IAB18-6']
    case 1586:
      return ['IAB18-4']
    case 1590:
      return ['IAB18-5']
    case 1592:
      return ['IAB18-5']
    case 1593:
      return ['IAB18-5']
    case 1594:
      return ['IAB18-5']
    case 1595:
      return ['IAB6']
    case 1596:
      return ['IAB18-5']
    case 1597:
      return ['IAB18-5']
    case 1598:
      return ['IAB18-5']
    case 1600:
      return ['IAB18-5']
    case 1601:
      return ['IAB18-5']
    case 1602:
      return ['IAB7-39']
    case 1604:
      return ['IAB18-5']
    case 1605:
      return ['IAB6']
    case 1606:
      return ['IAB18-5']
    case 1607:
      return ['IAB6']
    case 1608:
      return ['IAB6']
    case 1609:
      return ['IAB6']
    case 1610:
      return ['IAB6']
    case 1612:
      return ['IAB6']
    case 1614:
      return ['IAB6']
    case 1615:
      return ['IAB6']
    case 1616:
      return ['IAB18-5']
    case 1618:
      return ['IAB6']
    case 1642:
      return ['IAB18-5']
    case 1643:
      return ['IAB18-5']
    case 1644:
      return ['IAB18-5']
    case 1645:
      return ['IAB18-5']
    case 1646:
      return ['IAB18-5']
    case 1647:
      return ['IAB18-5']
    case 1649:
      return ['IAB18-5']
    case 1653:
      return ['IAB18-5']
    case 1655:
      return ['IAB18-5']
    case 1657:
      return ['IAB18-5']
    case 1660:
      return ['IAB18-5']
    case 1661:
      return ['IAB18-5']
    case 1662:
      return ['IAB18-5']
    case 1663:
      return ['IAB18-5']
    case 1664:
      return ['IAB18-5']
    case 1665:
      return ['IAB18-5']
    case 1666:
      return ['IAB18-5']
    case 1667:
      return ['IAB18-5']
    case 1668:
      return ['IAB18-5']
    case 1669:
      return ['IAB18-5']
    case 1670:
      return ['IAB18-5']
    case 1671:
      return ['IAB18-5']
    case 1672:
      return ['IAB18-5']
    case 1673:
      return ['IAB18-5']
    case 1696:
      return ['IAB18-5']
    case 1697:
      return ['IAB18-5']
    case 1698:
      return ['IAB18-5']
    case 1701:
      return ['IAB18-5']
    case 1702:
      return ['IAB18-5']
    case 1714:
      return ['IAB18-6']
    case 1725:
      return ['IAB19']
    case 1730:
      return ['IAB6']
    case 1731:
      return ['IAB6']
    case 1740:
      return ['IAB18-6']
    case 1741:
      return ['IAB18-6']
    case 1743:
      return ['IAB18-6']
    case 1745:
      return ['IAB18-6']
    case 1746:
      return ['IAB18-6']
    case 1748:
      return ['IAB18-6']
    case 1749:
      return ['IAB18-6']
    case 1750:
      return ['IAB6']
    case 1751:
      return ['IAB6']
    case 1752:
      return ['IAB6']
    case 1754:
      return ['IAB18-5']
    case 1755:
      return ['IAB18-5']
    case 1757:
      return ['IAB18-5']
    case 1758:
      return ['IAB18-5']
    case 1759:
      return ['IAB18-5']
    case 1760:
      return ['IAB18-5']
    case 1761:
      return ['IAB18-5']
    case 1762:
      return ['IAB18-5']
    case 1763:
      return ['IAB9']
    case 1764:
      return ['IAB6']
    case 1766:
      return ['IAB6']
    case 1767:
      return ['IAB6']
    case 1771:
      return ['IAB6']
    case 1773:
      return ['IAB18-5']
    case 1774:
      return ['IAB18-5']
    case 1775:
      return ['IAB18-5']
    case 1776:
      return ['IAB18-5']
    case 1777:
      return ['IAB18-5']
    case 1778:
      return ['IAB18-5']
    case 1779:
      return ['IAB18-5']
    case 1780:
      return ['IAB18-5']
    case 1781:
      return ['IAB18-5']
    case 1782:
      return ['IAB18-5']
    case 1784:
      return ['IAB18-5']
    case 1785:
      return ['IAB18-5']
    case 1786:
      return ['IAB18-5']
    case 1787:
      return ['IAB18-5']
    case 1788:
      return ['IAB18-5']
    case 1789:
      return ['IAB18-5']
    case 1790:
      return ['IAB18-5']
    case 1795:
      return ['IAB18-5']
    case 1797:
      return ['IAB18-6']
    case 1798:
      return ['IAB18-6']
    case 1799:
      return ['IAB18-6']
    case 1800:
      return ['IAB18-6']
    case 1801:
      return ['IAB18-5']
    case 1802:
      return ['IAB18-5']
    case 1803:
      return ['IAB18-5']
    case 1804:
      return ['IAB18-5']
    case 1805:
      return ['IAB18-5']
    case 1806:
      return ['IAB18-5']
    case 1807:
      return ['IAB18-5']
    case 1808:
      return ['IAB18-5']
    case 1809:
      return ['IAB18-5']
    case 1810:
      return ['IAB18-5']
    case 1811:
      return ['IAB18-5']
    case 1812:
      return ['IAB18-5']
    case 1813:
      return ['IAB18-5']
    case 1814:
      return ['IAB18-5']
    case 1815:
      return ['IAB18-5']
    case 1816:
      return ['IAB18-5']
    case 1817:
      return ['IAB18-5']
    case 1818:
      return ['IAB18-5']
    case 1819:
      return ['IAB18-5']
    case 1820:
      return ['IAB18-5']
    case 1821:
      return ['IAB18-5']
    case 1822:
      return ['IAB18-5']
    case 1823:
      return ['IAB18-5']
    case 1824:
      return ['IAB18-5']
    case 1825:
      return ['IAB18-5']
    case 1826:
      return ['IAB18-5']
    case 1827:
      return ['IAB18-5']
    case 1828:
      return ['IAB18-5']
    case 1829:
      return ['IAB18-5']
    case 1830:
      return ['IAB18-5']
    case 1834:
      return ['IAB18-5']
    case 1835:
      return ['IAB18-5']
    case 1837:
      return ['IAB18-5']
    case 1838:
      return ['IAB18-5']
    case 1839:
      return ['IAB18-5']
    case 1840:
      return ['IAB18-5']
    case 1841:
      return ['IAB18-5']
    case 1842:
      return ['IAB18-5']
    case 1843:
      return ['IAB18-5']
    case 1844:
      return ['IAB18-5']
    case 1845:
      return ['IAB18-5']
    case 1846:
      return ['IAB18-5']
    case 1847:
      return ['IAB18-6']
    case 1848:
      return ['IAB18-6']
    case 1849:
      return ['IAB18-6']
    case 1850:
      return ['IAB18-6']
    case 1851:
      return ['IAB18-6']
    case 1852:
      return ['IAB18-6']
    case 1858:
      return ['IAB18-5']
    case 1859:
      return ['IAB18-5']
    case 1861:
      return ['IAB18-5']
    case 1862:
      return ['IAB18-5']
    case 1863:
      return ['IAB18-1']
    case 1864:
      return ['IAB18-5']
    case 1865:
      return ['IAB18-5']
    case 1866:
      return ['IAB18-5']
    case 1867:
      return ['IAB18-5']
    case 1868:
      return ['IAB18-5']
    case 1870:
      return ['IAB18-5']
    case 1871:
      return ['IAB18-5']
    case 1872:
      return ['IAB18-5']
    case 1874:
      return ['IAB18-5']
    case 1875:
      return ['IAB18-5']
    case 1877:
      return ['IAB18-5']
    case 1878:
      return ['IAB18-5']
    case 1880:
      return ['IAB18-5']
    case 1881:
      return ['IAB18-6']
    case 1883:
      return ['IAB18-5']
    case 1886:
      return ['IAB18-5']
    case 1887:
      return ['IAB18-5']
    case 1902:
      return ['IAB18-1']
    case 1903:
      return ['IAB18-1']
    case 1904:
      return ['IAB18-1']
    case 1906:
      return ['IAB18-1']
    case 1907:
      return ['IAB18-5']
    case 1908:
      return ['IAB18-5']
    case 1917:
      return ['IAB18-5']
    case 1918:
      return ['IAB10']
    case 1919:
      return ['IAB10']
    case 1920:
      return ['IAB10']
    case 1924:
      return ['IAB10']
    case 1925:
      return ['IAB10']
    case 1926:
      return ['IAB10']
    case 1927:
      return ['IAB10']
    case 1928:
      return ['IAB10']
    case 1929:
      return ['IAB10']
    case 1930:
      return ['IAB10']
    case 1931:
      return ['IAB10']
    case 1932:
      return ['IAB10']
    case 1934:
      return ['IAB10']
    case 1935:
      return ['IAB10']
    case 1936:
      return ['IAB10']
    case 1937:
      return ['IAB10']
    case 1938:
      return ['IAB10']
    case 1939:
      return ['IAB10']
    case 1940:
      return ['IAB10']
    case 1941:
      return ['IAB10']
    case 1942:
      return ['IAB10']
    case 1943:
      return ['IAB10']
    case 1944:
      return ['IAB10']
    case 1945:
      return ['IAB10']
    case 1946:
      return ['IAB10']
    case 1947:
      return ['IAB10']
    case 1948:
      return ['IAB10']
    case 1949:
      return ['IAB10']
    case 1950:
      return ['IAB10']
    case 1951:
      return ['IAB10']
    case 1952:
      return ['IAB10']
    case 1953:
      return ['IAB10']
    case 1954:
      return ['IAB10']
    case 1955:
      return ['IAB10']
    case 1956:
      return ['IAB10']
    case 1957:
      return ['IAB10']
    case 1958:
      return ['IAB10']
    case 1959:
      return ['IAB10']
    case 1960:
      return ['IAB10']
    case 1961:
      return ['IAB10']
    case 1962:
      return ['IAB10']
    case 1963:
      return ['IAB10']
    case 1964:
      return ['IAB10']
    case 1965:
      return ['IAB10']
    case 1966:
      return ['IAB10']
    case 1967:
      return ['IAB10']
    case 1968:
      return ['IAB10']
    case 1969:
      return ['IAB10']
    case 1970:
      return ['IAB10']
    case 1974:
      return ['IAB10']
    case 2005:
      return ['IAB10']
    case 2006:
      return ['IAB10']
    case 2007:
      return ['IAB10']
    case 2008:
      return ['IAB10']
    case 2009:
      return ['IAB10']
    case 2010:
      return ['IAB10']
    case 2011:
      return ['IAB10']
    case 2012:
      return ['IAB18-6']
    case 2050:
      return ['IAB18-5']
    case 2051:
      return ['IAB18-5']
    case 2052:
      return ['IAB18-5']
    case 2055:
      return ['IAB18-1']
    case 2079:
      return ['IAB18-5']
    case 2080:
      return ['IAB18-5']
    case 2082:
      return ['IAB18-5']
    case 2083:
      return ['IAB18-5']
    case 2084:
      return ['IAB18-5']
    case 2093:
      return ['IAB16']
    case 2095:
      return ['IAB16']
    case 2096:
      return ['IAB16']
    case 2097:
      return ['IAB16']
    case 2098:
      return ['IAB16']
    case 2099:
      return ['IAB16']
    case 2109:
      return ['IAB16']
    case 2110:
      return ['IAB16']
    case 2111:
      return ['IAB16']
    case 2112:
      return ['IAB18-6']
    case 2113:
      return ['IAB16']
    case 2114:
      return ['IAB16']
    case 2115:
      return ['IAB9']
    case 2117:
      return ['IAB16']
    case 2118:
      return ['IAB16']
    case 2119:
      return ['IAB16']
    case 2120:
      return ['IAB16']
    case 2121:
      return ['IAB18-6']
    case 2122:
      return ['IAB16']
    case 2123:
      return ['IAB16']
    case 2124:
      return ['IAB16']
    case 2125:
      return ['IAB16']
    case 2126:
      return ['IAB16']
    case 2127:
      return ['IAB18-6']
    case 2128:
      return ['IAB16']
    case 2129:
      return ['IAB16']
    case 2130:
      return ['IAB18-6']
    case 2131:
      return ['IAB16']
    case 2133:
      return ['IAB16']
    case 2134:
      return ['IAB16']
    case 2136:
      return ['IAB16']
    case 2137:
      return ['IAB9']
    case 2138:
      return ['IAB16']
    case 2140:
      return ['IAB18-6']
    case 2142:
      return ['IAB9']
    case 2309:
      return ['IAB9']
    case 2312:
      return ['IAB1-1']
    case 2318:
      return ['IAB6']
    case 2319:
      return ['IAB1-1']
    case 2320:
      return ['IAB1-1']
    case 2336:
      return ['IAB1-1']
    case 2337:
      return ['IAB1-1']
    case 2338:
      return ['IAB1-1']
    case 2339:
      return ['IAB1-1']
    case 2340:
      return ['IAB1-1']
    case 2341:
      return ['IAB1-1']
    case 2342:
      return ['IAB1-1']
    case 2343:
      return ['IAB1-1']
    case 2344:
      return ['IAB1-1']
    case 2345:
      return ['IAB1-1']
    case 2346:
      return ['IAB1-1']
    case 2347:
      return ['IAB1-1']
    case 2348:
      return ['IAB1-1']
    case 2349:
      return ['IAB1-1']
    case 2350:
      return ['IAB1-1']
    case 2351:
      return ['IAB1-1']
    case 2352:
      return ['IAB1-1']
    case 2353:
      return ['IAB1-1']
    case 2354:
      return ['IAB1-1']
    case 2355:
      return ['IAB1-1']
    case 2356:
      return ['IAB1-1']
    case 2357:
      return ['IAB1-1']
    case 2358:
      return ['IAB1-1']
    case 2359:
      return ['IAB1-1']
    case 2360:
      return ['IAB1-1']
    case 2361:
      return ['IAB1-1']
    case 2362:
      return ['IAB1-1']
    case 2363:
      return ['IAB1-1']
    case 2364:
      return ['IAB1-1']
    case 2365:
      return ['IAB1-1']
    case 2484:
      return ['IAB16']
    case 2485:
      return ['IAB16']
    case 2486:
      return ['IAB16']
    case 2487:
      return ['IAB16']
    case 2488:
      return ['IAB18-6']
    case 2489:
      return ['IAB16']
    case 2490:
      return ['IAB18-6']
    case 2491:
      return ['IAB16']
    case 2492:
      return ['IAB9']
    case 2493:
      return ['IAB18-6']
    case 2494:
      return ['IAB18-6']
    case 2495:
      return ['IAB16']
    case 2496:
      return ['IAB16']
    case 2497:
      return ['IAB16']
    case 2498:
      return ['IAB16']
    case 2499:
      return ['IAB16']
    case 2500:
      return ['IAB16']
    case 2501:
      return ['IAB16']
    case 2502:
      return ['IAB9']
    case 2503:
      return ['IAB16']
    case 2504:
      return ['IAB9']
    case 2505:
      return ['IAB16']
    case 2506:
      return ['IAB16']
    case 2507:
      return ['IAB16']
    case 2508:
      return ['IAB16']
    case 2509:
      return ['IAB18-6']
    case 2510:
      return ['IAB16']
    case 2511:
      return ['IAB16']
    case 2512:
      return ['IAB16']
    case 2513:
      return ['IAB9']
    case 2514:
      return ['IAB9']
    case 2515:
      return ['IAB9']
    case 2516:
      return ['IAB16']
    case 2517:
      return ['IAB16']
    case 2518:
      return ['IAB16']
    case 2524:
      return ['IAB18-5']
    case 2525:
      return ['IAB18-5']
    case 2526:
      return ['IAB18-5']
    case 2527:
      return ['IAB18-5']
    case 2528:
      return ['IAB18-5']
    case 2529:
      return ['IAB18-5']
    case 2530:
      return ['IAB18-5']
    case 2531:
      return ['IAB18-5']
    case 2532:
      return ['IAB18-5']
    case 2533:
      return ['IAB18-5']
    case 2534:
      return ['IAB18-5']
    case 2535:
      return ['IAB18-5']
    case 2536:
      return ['IAB18-5']
    case 2537:
      return ['IAB18-5']
    case 2538:
      return ['IAB18-5']
    case 2539:
      return ['IAB17-35', 'IAB17-36', 'IAB18-5']
    case 2540:
      return ['IAB18-5']
    case 2541:
      return ['IAB18-5']
    case 2542:
      return ['IAB18-5']
    case 2543:
      return ['IAB18-5']
    case 2544:
      return ['IAB18-5']
    case 2545:
      return ['IAB18-5']
    case 2546:
      return ['IAB18-5']
    case 2547:
      return ['IAB18-5']
    case 2548:
      return ['IAB18-5']
    case 2549:
      return ['IAB18-5']
    case 2550:
      return ['IAB18-5']
    case 2551:
      return ['IAB18-5']
    case 2552:
      return ['IAB18-5']
    case 2553:
      return ['IAB18-5']
    case 2554:
      return ['IAB18-5']
    case 2555:
      return ['IAB18-5']
    case 2556:
      return ['IAB18-5']
    case 2557:
      return ['IAB18-5']
    case 2558:
      return ['IAB18-5']
    case 2559:
      return ['IAB18-5']
    case 2560:
      return ['IAB18-5']
    case 2561:
      return ['IAB18-5']
    case 2562:
      return ['IAB18-5']
    case 2563:
      return ['IAB18-5']
    case 2564:
      return ['IAB18-5']
    case 2565:
      return ['IAB18-5']
    case 2571:
      return ['IAB18-5']
    case 2573:
      return ['IAB18-5']
    case 2574:
      return ['IAB18-5']
    case 2575:
      return ['IAB18-5']
    case 2576:
      return ['IAB18-5']
    case 2577:
      return ['IAB18-5']
    case 2582:
      return ['IAB18-5']
    case 2583:
      return ['IAB18-5']
    case 2590:
      return ['IAB18-5']
    case 2596:
      return ['IAB18-5']
    case 2602:
      return ['IAB18-5']
    case 2604:
      return ['IAB18-5']
    case 2606:
      return ['IAB18-5']
    case 2609:
      return ['IAB18-5']
    case 2610:
      return ['IAB18-5']
    case 2612:
      return ['IAB18-5']
    case 2613:
      return ['IAB18-5']
    case 2614:
      return ['IAB18-5']
    case 2618:
      return ['IAB18-5']
    case 2619:
      return ['IAB18-5']
    case 2620:
      return ['IAB18-5']
    case 2621:
      return ['IAB18-5']
    case 2622:
      return ['IAB18-5']
    case 2623:
      return ['IAB18-5']
    case 2630:
      return ['IAB18-5']
    case 2632:
      return ['IAB18-5']
    case 2639:
      return ['IAB17-26']
    case 2640:
      return ['IAB17-8']
    case 2641:
      return ['IAB17-3']
    case 2642:
      return ['IAB18-5']
    case 2643:
      return ['IAB17-12', 'IAB18-5']
    case 2644:
      return ['IAB17-15', 'IAB18-5']
    case 2645:
      return ['IAB18-5']
    case 2646:
      return ['IAB17-27']
    case 2647:
      return ['IAB17-12', 'IAB18-5']
    case 2648:
      return ['IAB18-5']
    case 2649:
      return ['IAB17-25']
    case 2650:
      return ['IAB17-34']
    case 2651:
      return ['IAB18-5']
    case 2652:
      return ['IAB17-35']
    case 2653:
      return ['IAB17-36']
    case 2654:
      return ['IAB17-38']
    case 2655:
      return ['IAB17-40']
    case 2656:
      return ['IAB18-5']
    case 2657:
      return ['IAB18-5']
    case 2659:
      return ['IAB18-5']
    case 2661:
      return ['IAB18-5']
    case 2662:
      return ['IAB18-5']
    case 2663:
      return ['IAB18-5']
    case 2664:
      return ['IAB18-5']
    case 2672:
      return ['IAB17-26']
    case 2673:
      return ['IAB17-8']
    case 2674:
      return ['IAB17-3']
    case 2675:
      return ['IAB18-5']
    case 2676:
      return ['IAB17-12', 'IAB18-5']
    case 2677:
      return ['IAB17-15', 'IAB18-5']
    case 2678:
      return ['IAB18-5']
    case 2679:
      return ['IAB17-27']
    case 2680:
      return ['IAB17-12', 'IAB18-5']
    case 2681:
      return ['IAB17-25']
    case 2682:
      return ['IAB17-34']
    case 2683:
      return ['IAB17-35']
    case 2684:
      return ['IAB17-36']
    case 2685:
      return ['IAB17-38']
    case 2686:
      return ['IAB17-40']
    case 2690:
      return ['IAB18-5']
    case 2691:
      return ['IAB18-5']
    case 2692:
      return ['IAB18-5']
    case 2693:
      return ['IAB18-5']
    case 2695:
      return ['IAB18-5']
    case 2696:
      return ['IAB18-5']
    case 2697:
      return ['IAB18-5']
    case 2698:
      return ['IAB18-5']
    case 2701:
      return ['IAB18-5']
    case 2702:
      return ['IAB18-5']
    case 2704:
      return ['IAB18-5']
    case 2705:
      return ['IAB18-5']
    case 2707:
      return ['IAB18-5']
    case 2708:
      return ['IAB17-26']
    case 2709:
      return ['IAB18-5']
    case 2710:
      return ['IAB17-12', 'IAB18-5']
    case 2711:
      return ['IAB18-5']
    case 2712:
      return ['IAB17-27']
    case 2713:
      return ['IAB17-34']
    case 2714:
      return ['IAB18-5']
    case 2715:
      return ['IAB17-35']
    case 2716:
      return ['IAB17-36']
    case 2717:
      return ['IAB17-38']
    case 2718:
      return ['IAB18-5']
    case 2719:
      return ['IAB18-5']
    case 2720:
      return ['IAB18-5']
    case 2721:
      return ['IAB18-5']
    case 2722:
      return ['IAB18-5']
    case 2723:
      return ['IAB18-5']
    case 2724:
      return ['IAB18-5']
    case 2726:
      return ['IAB18-5']
    case 2727:
      return ['IAB18-5']
    case 2728:
      return ['IAB18-5']
    case 2729:
      return ['IAB18-5']
    case 2730:
      return ['IAB18-5']
    case 2732:
      return ['IAB18-5']
    case 2733:
      return ['IAB18-5']
    case 2734:
      return ['IAB18-5']
    case 2735:
      return ['IAB17-26']
    case 2737:
      return ['IAB18-5']
    case 2738:
      return ['IAB17-12', 'IAB18-5']
    case 2742:
      return ['IAB18-5']
    case 2743:
      return ['IAB17-27']
    case 2744:
      return ['IAB17-34']
    case 2745:
      return ['IAB18-5']
    case 2746:
      return ['IAB17-35']
    case 2748:
      return ['IAB17-36']
    case 2749:
      return ['IAB17-38']
    case 2750:
      return ['IAB18-5']
    case 2751:
      return ['IAB18-5']
    case 2752:
      return ['IAB18-5']
    case 2753:
      return ['IAB18-5']
    case 2910:
      return ['IAB18-5']
    case 2911:
      return ['IAB18-5']
    case 2912:
      return ['IAB18-5']
    case 2913:
      return ['IAB18-5']
    case 2914:
      return ['IAB18-5']
    case 2915:
      return ['']
    case 2917:
      return ['IAB1-3']
    case 2918:
      return ['IAB1-3']
    case 2920:
      return ['IAB1-3']
    case 2921:
      return ['IAB1-3']
    case 2922:
      return ['IAB10-7']
    case 2923:
      return ['IAB10-7']
    case 2924:
      return ['IAB10-7']
    case 2925:
      return ['IAB10-7']
    case 2926:
      return ['IAB10-7']
    case 2927:
      return ['IAB18-5']
    case 2928:
      return ['IAB18-5']
    case 2929:
      return ['IAB18-6']
    case 2931:
      return ['IAB18-6']
    case 2932:
      return ['IAB18-6']
    case 2933:
      return ['IAB18-6']
    case 2934:
      return ['IAB18-6']
    case 2935:
      return ['IAB18-6']
    case 2936:
      return ['IAB18-6']
    case 2937:
      return ['IAB18-6']
    case 2938:
      return ['IAB18-6']
    case 2939:
      return ['IAB18-6']
    case 2940:
      return ['IAB18-6']
    case 2941:
      return ['IAB18-6']
    case 2942:
      return ['IAB18-6']
    case 2943:
      return ['IAB18-6']
    case 2944:
      return ['IAB17', 'IAB18-6']
    case 2945:
      return ['IAB18-6']
    case 2949:
      return ['IAB18-5']
    case 2950:
      return ['IAB18-5']
    case 2951:
      return ['IAB18-5']
    case 2952:
      return ['IAB18-5']
    case 2953:
      return ['IAB18-5']
    case 2954:
      return ['IAB18-5']
    case 2955:
      return ['IAB18-5']
    case 2956:
      return ['IAB18-6']
    case 2957:
      return ['IAB18-6']
    case 2958:
      return ['IAB18-6']
    case 2959:
      return ['IAB18-6']
    case 2960:
      return ['IAB18-6']
    case 2961:
      return ['IAB17', 'IAB18-6']
    case 2962:
      return ['IAB18-6']
    case 2963:
      return ['IAB18-6']
    case 2964:
      return ['IAB18-6']
    case 2965:
      return ['IAB18-6']
    case 2966:
      return ['IAB18-6']
    case 2967:
      return ['IAB18-6']
    case 2968:
      return ['IAB18-5']
    case 2969:
      return ['IAB18-5']
    case 2970:
      return ['IAB18-5']
    case 2983:
      return ['IAB18-5']
    case 2984:
      return ['IAB18-6']
    case 2985:
      return ['IAB18-5']
    case 2986:
      return ['IAB18-6']
    case 2987:
      return ['IAB18-5']
    case 2988:
      return ['IAB18-5']
    case 2990:
      return ['IAB18-5']
    case 2991:
      return ['IAB18-6']
    case 2992:
      return ['IAB18-5']
    case 2993:
      return ['IAB18-5']
    case 2994:
      return ['IAB19']
    case 2995:
      return ['IAB19']
    case 2996:
      return ['IAB19']
    case 2997:
      return ['IAB19']
    case 2998:
      return ['IAB19']
    case 2999:
      return ['IAB19-6']
    case 3000:
      return ['IAB19']
    case 3001:
      return ['IAB19']
    case 3002:
      return ['IAB9-30', 'IAB19-29']
    case 3003:
      return ['IAB9-30', 'IAB19-29']
    case 3004:
      return ['IAB19']
    case 3005:
      return ['IAB19']
    case 3006:
      return ['IAB19']
    case 3007:
      return ['IAB19']
    case 3008:
      return ['IAB19']
    case 3009:
      return ['IAB19']
    case 3010:
      return ['IAB19']
    case 3011:
      return ['IAB19']
    case 3012:
      return ['IAB19']
    case 3013:
      return ['IAB19']
    case 3014:
      return ['IAB19']
    case 3015:
      return ['IAB19']
    case 3017:
      return ['IAB19']
    case 3020:
      return ['IAB19']
    case 3021:
      return ['IAB19']
    case 3022:
      return ['IAB19']
    case 3023:
      return ['IAB19']
    case 3024:
      return ['IAB19']
    case 3025:
      return ['IAB9-30', 'IAB19-29']
    case 3026:
      return ['IAB9-30', 'IAB19-29']
    case 3027:
      return ['IAB19']
    case 3028:
      return ['IAB19']
    case 3029:
      return ['IAB19']
    case 3030:
      return ['IAB19']
    case 3031:
      return ['IAB19']
    case 3032:
      return ['IAB19']
    case 3033:
      return ['IAB19']
    case 3034:
      return ['IAB19']
    case 3035:
      return ['IAB19']
    case 3036:
      return ['IAB1-6']
    case 3037:
      return ['IAB19']
    case 3038:
      return ['IAB19']
    case 3039:
      return ['IAB19']
    case 3040:
      return ['IAB19']
    case 3041:
      return ['IAB19']
    case 3042:
      return ['IAB19']
    case 3043:
      return ['IAB19']
    case 3044:
      return ['IAB19']
    case 3045:
      return ['IAB19']
    case 3046:
      return ['IAB19']
    case 3047:
      return ['IAB19']
    case 3048:
      return ['IAB19']
    case 3049:
      return ['IAB18-6']
    case 3050:
      return ['IAB18-6']
    case 3051:
      return ['IAB19']
    case 3052:
      return ['IAB19']
    case 3053:
      return ['IAB19']
    case 3054:
      return ['IAB9-23', 'IAB19']
    case 3055:
      return ['IAB19']
    case 3056:
      return ['IAB19']
    case 3057:
      return ['IAB19']
    case 3058:
      return ['IAB19']
    case 3059:
      return ['IAB19']
    case 3060:
      return ['IAB9-23', 'IAB19']
    case 3061:
      return ['IAB9-23', 'IAB19']
    case 3062:
      return ['IAB9-23', 'IAB19']
    case 3064:
      return ['IAB9-23', 'IAB19']
    case 3065:
      return ['IAB9-23', 'IAB19']
    case 3068:
      return ['IAB18-6', 'IAB9-23', 'IAB19']
    case 3069:
      return ['IAB9-23', 'IAB19']
    case 3071:
      return ['IAB19']
    case 3072:
      return ['IAB19']
    case 3073:
      return ['IAB19']
    case 3074:
      return ['IAB9-23', 'IAB19']
    case 3075:
      return ['IAB9-23', 'IAB19']
    case 3076:
      return ['IAB9-23', 'IAB19']
    case 3077:
      return ['IAB9-23', 'IAB19']
    case 3078:
      return ['IAB9-23', 'IAB19']
    case 3082:
      return ['IAB19-9']
    case 3083:
      return ['IAB19-9']
    case 3084:
      return ['IAB19-9']
    case 3085:
      return ['IAB19-9']
    case 3086:
      return ['IAB19-9']
    case 3087:
      return ['IAB19-9']
    case 3089:
      return ['IAB19-9']
    case 3093:
      return ['IAB19-9']
    case 3094:
      return ['IAB19-9']
    case 3095:
      return ['IAB19-9']
    case 3096:
      return ['IAB19-9']
    case 3097:
      return ['IAB19-9']
    case 3098:
      return ['IAB19-9']
    case 3099:
      return ['IAB19-9']
    case 3100:
      return ['IAB19-9']
    case 3101:
      return ['IAB19-9']
    case 3102:
      return ['IAB19-9']
    case 3103:
      return ['IAB19-9']
    case 3104:
      return ['IAB19-9']
    case 3105:
      return ['IAB19-9']
    case 3106:
      return ['IAB19-9']
    case 3107:
      return ['IAB19-9']
    case 3108:
      return ['IAB19-9']
    case 3109:
      return ['IAB19']
    case 3110:
      return ['IAB19']
    case 3111:
      return ['IAB19']
    case 3112:
      return ['IAB19']
    case 3113:
      return ['IAB19']
    case 3114:
      return ['IAB19']
    case 3115:
      return ['IAB19']
    case 3122:
      return ['IAB19-9']
    case 3123:
      return ['IAB19-9']
    case 3124:
      return ['IAB19-9']
    case 3125:
      return ['IAB19-9']
    case 3126:
      return ['IAB18-6']
    case 3127:
      return ['IAB19-9']
    case 3128:
      return ['IAB19']
    case 3129:
      return ['IAB19']
    case 3130:
      return ['IAB19']
    case 3131:
      return ['IAB19-9']
    case 3132:
      return ['IAB19-9']
    case 3133:
      return ['IAB19-9']
    case 3134:
      return ['IAB19-9']
    case 3135:
      return ['IAB19-9']
    case 3136:
      return ['IAB19-9']
    case 3137:
      return ['IAB19']
    case 3138:
      return ['IAB19']
    case 3139:
      return ['IAB19']
    case 3140:
      return ['IAB19']
    case 3141:
      return ['IAB19']
    case 3142:
      return ['IAB19-9']
    case 3143:
      return ['IAB19-9']
    case 3144:
      return ['IAB19-9']
    case 3145:
      return ['IAB19-9']
    case 3146:
      return ['IAB19-9']
    case 3147:
      return ['IAB19-9']
    case 3148:
      return ['IAB19']
    case 3149:
      return ['IAB19']
    case 3150:
      return ['IAB19']
    case 3151:
      return ['IAB19']
    case 3152:
      return ['IAB19']
    case 3154:
      return ['IAB10']
    case 3155:
      return ['IAB10']
    case 3156:
      return ['IAB10']
    case 3157:
      return ['IAB10']
    case 3158:
      return ['IAB10']
    case 3159:
      return ['IAB10']
    case 3160:
      return ['IAB10']
    case 3162:
      return ['IAB10']
    case 3163:
      return ['IAB10']
    case 3164:
      return ['IAB10']
    case 3165:
      return ['IAB10']
    case 3166:
      return ['IAB10']
    case 3167:
      return ['IAB10']
    case 3168:
      return ['IAB10']
    case 3169:
      return ['IAB10']
    case 3170:
      return ['IAB10']
    case 3171:
      return ['IAB10']
    case 3172:
      return ['IAB10']
    case 3173:
      return ['IAB10']
    case 3175:
      return ['IAB10']
    case 3176:
      return ['IAB10']
    case 3177:
      return ['IAB10']
    case 3178:
      return ['IAB10']
    case 3179:
      return ['IAB10']
    case 3180:
      return ['IAB10']
    case 3181:
      return ['IAB10']
    case 3182:
      return ['IAB10']
    case 3183:
      return ['IAB10']
    case 3184:
      return ['IAB10']
    case 3185:
      return ['IAB10']
    case 3186:
      return ['IAB10']
    case 3187:
      return ['IAB10']
    case 3188:
      return ['IAB1-1']
    case 3189:
      return ['IAB10']
    case 3190:
      return ['IAB10']
    case 3191:
      return ['IAB10']
    case 3192:
      return ['IAB10']
    case 3193:
      return ['IAB10']
    case 3194:
      return ['IAB10']
    case 3195:
      return ['IAB10']
    case 3196:
      return ['IAB10']
    case 3197:
      return ['IAB10']
    case 3198:
      return ['IAB10']
    case 3199:
      return ['IAB10']
    case 3204:
      return ['IAB10']
    case 3205:
      return ['IAB10']
    case 3207:
      return ['IAB10']
    case 3208:
      return ['IAB10']
    case 3209:
      return ['IAB10']
    case 3210:
      return ['IAB10']
    case 3211:
      return ['IAB10']
    case 3221:
      return ['IAB10']
    case 3222:
      return ['IAB10']
    case 3224:
      return ['IAB9-10']
    case 3225:
      return ['IAB9-5']
    case 3226:
      return ['IAB9-5']
    case 3227:
      return ['IAB9-5']
    case 3228:
      return ['IAB9-10']
    case 3229:
      return ['IAB9-10']
    case 3230:
      return ['IAB9-10']
    case 3231:
      return ['IAB9-10']
    case 3232:
      return ['IAB19-9', 'IAB9-30']
    case 3233:
      return ['IAB9-10']
    case 3234:
      return ['IAB9-10']
    case 3235:
      return ['IAB9-10']
    case 3236:
      return ['IAB9-10']
    case 3237:
      return ['IAB9-10']
    case 3238:
      return ['IAB9-10']
    case 3239:
      return ['IAB9-10']
    case 3240:
      return ['IAB9-10']
    case 3241:
      return ['IAB9-10']
    case 3243:
      return ['IAB9-10']
    case 3244:
      return ['IAB9-10']
    case 3245:
      return ['IAB9-10']
    case 3246:
      return ['IAB9-10']
    case 3247:
      return ['IAB9-10']
    case 3248:
      return ['IAB9-10']
    case 3249:
      return ['IAB9-10']
    case 3250:
      return ['IAB9-10']
    case 3251:
      return ['IAB9-10']
    case 3252:
      return ['IAB9-10']
    case 3253:
      return ['IAB9-10']
    case 3254:
      return ['IAB9-10']
    case 3255:
      return ['IAB9-10']
    case 3256:
      return ['IAB9-10']
    case 3257:
      return ['IAB9-10']
    case 3258:
      return ['IAB9-10']
    case 3259:
      return ['IAB9-10']
    case 3260:
      return ['IAB9-10']
    case 3261:
      return ['IAB9-10']
    case 3262:
      return ['IAB9-10']
    case 3263:
      return ['IAB9-10']
    case 3264:
      return ['IAB9-10']
    case 3265:
      return ['IAB9-10']
    case 3266:
      return ['IAB9-10']
    case 3267:
      return ['IAB18-5']
    case 3268:
      return ['IAB18-5']
    case 3269:
      return ['IAB18-6']
    case 3270:
      return ['IAB6']
    case 3271:
      return ['IAB6']
    case 3272:
      return ['IAB6']
    case 3273:
      return ['IAB6']
    case 3274:
      return ['IAB6']
    case 3275:
      return ['IAB6']
    case 3276:
      return ['IAB10-7']
    case 3277:
      return ['IAB18-6']
    case 3278:
      return ['IAB6']
    case 3279:
      return ['IAB6']
    case 3280:
      return ['IAB6']
    case 3281:
      return ['IAB6']
    case 3282:
      return ['IAB6']
    case 3283:
      return ['IAB6']
    case 3284:
      return ['IAB6']
    case 3285:
      return ['IAB6']
    case 3286:
      return ['IAB6']
    case 3287:
      return ['IAB6']
    case 3288:
      return ['IAB6']
    case 3289:
      return ['IAB6']
    case 3290:
      return ['IAB6']
    case 3291:
      return ['IAB6']
    case 3292:
      return ['IAB6']
    case 3293:
      return ['IAB6']
    case 3294:
      return ['IAB6']
    case 3295:
      return ['IAB6']
    case 3296:
      return ['IAB6']
    case 3297:
      return ['IAB6']
    case 3298:
      return ['IAB6']
    case 3299:
      return ['IAB6']
    case 3300:
      return ['IAB6']
    case 3301:
      return ['IAB6']
    case 3302:
      return ['IAB6']
    case 3303:
      return ['IAB6']
    case 3304:
      return ['IAB6']
    case 3305:
      return ['IAB6']
    case 3306:
      return ['IAB10-7']
    case 3307:
      return ['IAB10-7']
    case 3308:
      return ['IAB6']
    case 3309:
      return ['IAB6']
    case 3310:
      return ['IAB6']
    case 3311:
      return ['IAB9']
    case 3312:
      return ['IAB9']
    case 3313:
      return ['IAB9']
    case 3314:
      return ['IAB9']
    case 3315:
      return ['IAB6']
    case 3316:
      return ['IAB6']
    case 3317:
      return ['IAB6']
    case 3318:
      return ['IAB1-1']
    case 3319:
      return ['IAB9']
    case 3320:
      return ['IAB9']
    case 3321:
      return ['IAB9']
    case 3322:
      return ['IAB9']
    case 3323:
      return ['IAB9']
    case 3324:
      return ['IAB9']
    case 3325:
      return ['IAB9']
    case 3326:
      return ['IAB9']
    case 3327:
      return ['IAB9']
    case 3328:
      return ['IAB9']
    case 3329:
      return ['IAB9']
    case 3330:
      return ['IAB9']
    case 3331:
      return ['IAB9']
    case 3332:
      return ['IAB9']
    case 3333:
      return ['IAB9']
    case 3334:
      return ['IAB9']
    case 3335:
      return ['IAB9']
    case 3336:
      return ['IAB9']
    case 3337:
      return ['IAB9']
    case 3338:
      return ['IAB9']
    case 3339:
      return ['IAB9']
    case 3340:
      return ['IAB9']
    case 3341:
      return ['IAB9']
    case 3342:
      return ['IAB9']
    case 3343:
      return ['IAB9']
    case 3344:
      return ['IAB9']
    case 3345:
      return ['IAB9']
    case 3346:
      return ['IAB9']
    case 3347:
      return ['IAB9']
    case 3348:
      return ['IAB9']
    case 3349:
      return ['IAB9']
    case 3350:
      return ['IAB9']
    case 3351:
      return ['IAB9']
    case 3352:
      return ['IAB9']
    case 3353:
      return ['IAB6']
    case 3354:
      return ['IAB6']
    case 3355:
      return ['IAB9']
    case 3356:
      return ['IAB9']
    case 3357:
      return ['IAB9']
    case 3358:
      return ['IAB9']
    case 3359:
      return ['IAB6']
    case 3360:
      return ['IAB19']
    case 3361:
      return ['IAB9']
    case 3362:
      return ['IAB9']
    case 3363:
      return ['IAB9']
    case 3364:
      return ['IAB19']
    case 3365:
      return ['IAB9']
    case 3366:
      return ['IAB19']
    case 3367:
      return ['IAB9']
    case 3368:
      return ['IAB9']
    case 3369:
      return ['IAB9']
    case 3370:
      return ['IAB9']
    case 3371:
      return ['IAB9']
    case 3372:
      return ['IAB9']
    case 3373:
      return ['IAB9']
    case 3374:
      return ['IAB9']
    case 3375:
      return ['IAB9']
    case 3376:
      return ['IAB2']
    case 3377:
      return ['IAB2']
    case 3378:
      return ['IAB2']
    case 3379:
      return ['IAB2']
    case 3380:
      return ['IAB2']
    case 3381:
      return ['IAB2']
    case 3382:
      return ['IAB2']
    case 3383:
      return ['IAB2']
    case 3384:
      return ['IAB2']
    case 3385:
      return ['IAB2']
    case 3386:
      return ['IAB2']
    case 3387:
      return ['IAB2']
    case 3388:
      return ['IAB2']
    case 3389:
      return ['IAB2']
    case 3390:
      return ['IAB2']
    case 3391:
      return ['IAB2']
    case 3392:
      return ['IAB2']
    case 3393:
      return ['IAB6']
    case 3394:
      return ['IAB6']
    case 3395:
      return ['IAB6']
    case 3396:
      return ['IAB6']
    case 3397:
      return ['IAB6']
    case 3398:
      return ['IAB6']
    case 3399:
      return ['IAB6']
    case 3400:
      return ['IAB6']
    case 3401:
      return ['IAB6']
    case 3402:
      return ['IAB6']
    case 3403:
      return ['IAB6']
    case 3404:
      return ['IAB6']
    case 3405:
      return ['IAB6']
    case 3406:
      return ['IAB6']
    case 3407:
      return ['IAB6']
    case 3408:
      return ['IAB6']
    case 3409:
      return ['IAB6']
    case 3410:
      return ['IAB6']
    case 3411:
      return ['IAB6']
    case 3412:
      return ['IAB6']
    case 3413:
      return ['IAB6']
    case 3414:
      return ['IAB6']
    case 3415:
      return ['IAB6']
    case 3416:
      return ['IAB6']
    case 3417:
      return ['IAB6']
    case 3418:
      return ['IAB6']
    case 3419:
      return ['IAB6']
    case 3420:
      return ['IAB6']
    case 3421:
      return ['IAB6']
    case 3422:
      return ['IAB6']
    case 3423:
      return ['IAB6']
    case 3424:
      return ['IAB6']
    case 3425:
      return ['IAB6']
    case 3426:
      return ['IAB6']
    case 3427:
      return ['IAB6']
    case 3428:
      return ['IAB6']
    case 3429:
      return ['IAB6']
    case 3430:
      return ['IAB6']
    case 3431:
      return ['IAB6']
    case 3432:
      return ['IAB6']
    case 3433:
      return ['IAB6']
    case 3434:
      return ['IAB6']
    case 3435:
      return ['IAB6']
    case 3436:
      return ['IAB6']
    case 3437:
      return ['IAB6']
    case 3438:
      return ['IAB6']
    case 3439:
      return ['IAB6']
    case 3440:
      return ['IAB6']
    case 3441:
      return ['IAB6']
    case 3442:
      return ['IAB6']
    case 3443:
      return ['IAB6']
    case 3444:
      return ['IAB6']
    case 3445:
      return ['IAB6']
    case 3446:
      return ['IAB6']
    case 3447:
      return ['IAB6']
    case 3448:
      return ['IAB6']
    case 3449:
      return ['IAB6']
    case 3450:
      return ['IAB6']
    case 3451:
      return ['IAB6']
    case 3452:
      return ['IAB6']
    case 3453:
      return ['IAB6']
    case 3454:
      return ['IAB6']
    case 3455:
      return ['IAB6']
    case 3456:
      return ['IAB6']
    case 3457:
      return ['IAB6']
    case 3458:
      return ['IAB6']
    case 3459:
      return ['IAB6']
    case 3460:
      return ['IAB6']
    case 3461:
      return ['IAB6']
    case 3462:
      return ['IAB6']
    case 3463:
      return ['IAB6']
    case 3464:
      return ['IAB6']
    case 3465:
      return ['IAB6']
    case 3466:
      return ['IAB19']
    case 3467:
      return ['IAB1']
    case 3468:
      return ['IAB9']
    case 3469:
      return ['IAB9']
    case 3470:
      return ['IAB9']
    case 3471:
      return ['IAB9']
    case 3472:
      return ['IAB9']
    case 3473:
      return ['IAB9']
    case 3474:
      return ['IAB9']
    case 3475:
      return ['IAB9']
    default:
      return null
  }
}
